import { useSelector } from 'react-redux';
import { getAuth } from '../selectors/auth';
import { AlbumState } from '../data/models/albumState';

export default function useAuthUtilities() {
  const {
    hasInternalAccess,
    hasWriteAccess,
    hasProjectServiceRead,
    hasProjectServiceWrite,
    hasProjectServiceUiAccess,
  } = useSelector(getAuth);

  const canUserSeeSubmitForImportButton = () => {
    return hasInternalAccess && hasWriteAccess;
  };

  const canUserSeeReturnToDraftButton = () => {
    return hasWriteAccess;
  };

  const canUserSeeReturnToUnderReviewButton = () => {
    return hasInternalAccess && hasWriteAccess;
  };

  const canUserEditUnderReview = () => {
    return hasInternalAccess && hasWriteAccess;
  };

  const canUserEditPendingImport = () => {
    return hasInternalAccess && hasWriteAccess;
  };

  const canUserEditProduct = (state: AlbumState) => {
    if (
      state === AlbumState.Draft ||
      state === AlbumState.Rejected ||
      state === AlbumState.Error
    ) {
      return hasWriteAccess;
    } else if (state === AlbumState.UnderReview) {
      return canUserEditUnderReview();
    } else if (state === AlbumState.PendingImport) {
      return canUserEditPendingImport();
    }
    return false;
  };

  const canUserViewInternalFields = () => {
    return hasInternalAccess;
  };

  const canUserReadProjectService = () => {
    return hasProjectServiceRead;
  };

  const canUserWriteProjectService = () => {
    return hasProjectServiceWrite;
  };

  const canUserAccessProjectServiceUi = () => {
    return hasProjectServiceUiAccess;
  };

  const canUserSeeRejectButton = () => {
    return hasInternalAccess && hasWriteAccess;
  };

  const canUserSeeReleaseButton = () => {
    return hasInternalAccess && hasWriteAccess;
  };

  const isInternalUser = () => {
    return hasInternalAccess;
  };

  const canUserAccessEditUrl = () => {
    return hasWriteAccess;
  };

  return {
    canUserSeeSubmitForImportButton,
    canUserSeeReturnToUnderReviewButton,
    canUserSeeReturnToDraftButton,
    canUserEditUnderReview,
    canUserEditProduct,
    canUserViewInternalFields,
    canUserReadProjectService,
    canUserWriteProjectService,
    canUserAccessProjectServiceUi,
    canUserSeeRejectButton,
    canUserSeeReleaseButton,
    isInternalUser,
    canUserAccessEditUrl,
  };
}
